import { createSelector } from 'reselect';
import { getState } from '../store/selectors';

const getSettings = createSelector(getState, ({ settings }) => settings);

export const getSettingsSilentVisible = createSelector(
  getSettings,
  ({ silentVisible }) => silentVisible,
);
